<template>
  <b-modal
    centered
    id="request-device-error"
    modal-class="overflow-hidden"
    static
    scrollable
    hide-footer
    @hidden="onHidden"
    :no-close-on-backdrop="true"
    ignore-enforce-focus-selector="input"
  >
    <template #modal-header="">
      <h5>Thêm thiết bị</h5>
      <b-button size="sm" variant="light" @click="closeModalRequestDevice()"> x </b-button>
    </template>
    <ValidationObserver v-slot="{ handleSubmit }">
      <form @submit.prevent="handleSubmit(updateDevice)">
        <div>
          <ValidationProvider rules="required" vid="deviceId" name="Serial thiết bị">
            <div class="form-group" slot-scope="{ errors }">
              <label>Serial thiết bị<span style="color: red"> *</span></label>
              <div v-if="dataRequest.edit === true && dataRequest.deviceId">
                <input type="text" :value="dataRequest.serial" :disabled="true" />
              </div>
              <Select2
                v-else
                v-model="dataRequest.deviceId"
                @change="preareData(dataRequest)"
                :options="dataSerial"
                placeholder="Chọn serial thiết bị"
              />
              <p class="text-danger">{{ errors[0] }}</p>
            </div>
          </ValidationProvider>
          <ValidationProvider rules="" vid="errorsIds" name="Các lỗi">
            <div class="form-group" slot-scope="{ errors }">
              <label>Các lỗi <span style="color: red"> *</span></label>
              <select2-multiple-control
                v-model="dataRequest.errorIds"
                :options="listDataError"
                :settings="{ placeholder: 'Chọn các lỗi' }"
              ></select2-multiple-control>
              <p class="text-danger">{{ errors[0] }}</p>
            </div>
          </ValidationProvider>
          <ValidationProvider rules="required" vid="reason" name="Đối tượng gây lỗi">
            <div class="form-group" slot-scope="{ errors }">
              <label>Đối tượng gây lỗi <span style="color: red"> *</span></label>
              <Select2
                ref="dataRequestType"
                v-model="dataRequest.reason"
                :options="Config.faultMaker"
                placeholder="Chọn đối tượng gây lỗi"
              />
              <p class="text-danger">{{ errors[0] }}</p>
            </div>
          </ValidationProvider>
          <ValidationProvider rules="minMaxName_6" vid="note" name="Ghi chú">
            <div class="form-group" slot-scope="{ errors }">
              <label>Ghi chú</label>
              <div>
                <input type="text" class="form-control" v-model="dataRequest.note" />
                <p class="text-danger">{{ errors[0] }}</p>
              </div>
            </div>
          </ValidationProvider>
          <div>
            <UploadMultiple
              @syncFile="syncFile"
              :lsData="fileUploads"
              :maxFile="20"
              uniqueKey="images"
            />
          </div>
        </div>
        <div class="div-btn">
          <b-button
            class="btn-style"
            size="sm"
            type="button"
            variant="light"
            @click="closeModalRequestDevice()"
          >
            Hủy bỏ
          </b-button>
          <b-button class="btn-style" type="submit" size="sm" variant="primary">
            Xác nhận
          </b-button>
        </div>
      </form>
    </ValidationObserver>
    <VueLoadingOverlay :active.sync="showLoading" :is-full-page="true"></VueLoadingOverlay>
  </b-modal>
</template>

<script>
  import { DeviceService } from '@/services/device.service'
  import UploadMultiple from '@/components/UploadMultiple.vue'
  import { CommonService } from '@/services/common.service'
  import Config from '@/thirdParty/config'
  export default {
    components: { UploadMultiple },
    name: 'modal-request-device',
    props: {
      dataSerial: {
        type: Array,
        default: Array,
      },
      typeWarranty: {
        type: String,
        default: 'UNSUCCESSFUL',
      },
      lsData: {
        type: Object,
        default: Object,
      },
      closeModalRequestDevice: {
        type: Function,
      },
    },
    data() {
      return {
        Config,
        listDataError: [],
        showLoading: false,
        errorsIds: [],
        dataRequest: {},
      }
    },
    created() {
      if (this.lsData) {
        this.dataRequest = this.lsData ?? []
        this.fileUploads = this.dataRequest.imgErrors
        this.preareData(this.dataRequest)
      }
    },
    watch: {
      lsData(val) {
        if (val && val.edit) {
          this.preareData(val)
          this.errorsIds = val.errorsIds
          this.dataRequest = val ?? []
        }
      },
    },
    methods: {
      async updateDevice() {
        if (this.dataRequest.errorIds.length === 0) {
          this.showFailMx('Các lỗi không được để trống')
          return
        }
        const typeError = this.findErrorType()
        let files = []
        if (this.fileUploads && this.fileUploads.length > 0) {
          files = await Promise.all(this.fileUploads.map(s => this.sendFile(s)))
        }
        const data = {
          deviceId: this.dataRequest.deviceId,
          errorIds: this.dataRequest.errorIds,
          errors: typeError.errorDescription,
          note: this.dataRequest.note,
          reason: this.dataRequest.reason,
          typeError: typeError.maxLevelType,
          edit: this.dataRequest.edit,
          abbreviation: this.dataRequest.abbreviation,
          imgErrors: files.map(s => s.urlFile),
        }
        this.$emit('updateDevice', data)
      },
      onHidden() {
        this.$emit('onHidden')
        this.dataRequest.deviceId = ''
        this.errorsIds = []
        this.dataRequest.note = ''
        this.dataRequest.reason = ''
      },
      async preareData(dataDevice) {
        if (dataDevice.edit === true) {
          const params = {
            abbreviation: dataDevice.abbreviation,
          }
          this.getListError(params)
        } else {
          const data = this.dataSerial.find(item => item.id === dataDevice.deviceId)
          this.dataRequest.abbreviation = data.abbreviation
          const params = {
            abbreviation: data.abbreviation,
          }
          this.getListError(params)
        }
      },
      async getListError(params) {
        try {
          this.showLoading = true
          const res = await DeviceService.getListError(params)
          if (this.typeWarranty === 'SUCCESS') {
            const filteredData = res.data.filter(item => item.level === 1)
            this.listDataError = filteredData.map(({ id, description, typeDevice, level }) => {
              return { id, text: description, typeDevice, level }
            })
          } else {
            this.listDataError = res.data.map(({ id, description, typeDevice, level }) => {
              return { id, text: description, typeDevice, level }
            })
          }
        } catch (error) {
          console.log(error)
        } finally {
          this.showLoading = false
        }
      },
      cancel() {
        this.$bvModal.hide('request-device-error')
      },
      findErrorType() {
        // lay ly do loi
        const filteredData = this.listDataError.filter(item =>
          this.dataRequest.errorIds.includes(item.id)
        )
        const errorDescription = filteredData.map(item => item.text)
        // lay typeDevice
        const maxLevelType =
          filteredData.length === 1
            ? filteredData[0].typeDevice
            : filteredData.reduce((maxItem, currentItem) => {
                if (parseInt(currentItem.level) > parseInt(maxItem.level)) {
                  return currentItem
                } else {
                  return maxItem
                }
              }).typeDevice
        return { errorDescription, maxLevelType }
      },
      syncFile(files) {
        this.fileUploads = files
      },
      async sendFile(item) {
        try {
          this.showLoading = true
          if (item.file && item.status !== 'uploaded') {
            const formData = new FormData()
            formData.append('files', item.file)
            formData.append('folderName', 'NextCrm')
            const data = await CommonService.uploadImg(formData)
            const urlFile = data.data[0]
            item.url = urlFile
            item.status = 'uploaded'
            return { urlFile, type: item.type }
          } else return { urlFile: item.url, type: item.type }
        } catch (error) {
          console.log(error)
        } finally {
          this.showLoading = false
        }
      },
    },
  }
</script>

<style scoped>
  .btn-style {
    border-radius: 0.25rem;
    line-height: 1.5;
    padding: 0.4rem 0.75rem;
    font-weight: 400;
    margin: 0.25rem;
  }
  .div-btn {
    text-align: right;
  }
</style>
